//cross-filter utilities
export function applyFilters(records, filters, { excludeField } = {}) {
	const active = Array.from(filters.entries()).filter(([, set]) => set?.size);
	if (!active.length) return records;
	return records.filter(r =>
		active.every(([field, set]) => {
			if (field === excludeField) return true;
			const val = r[field];
			if (Array.isArray(val)) return val.some(v => set.has(String(v)));
			return set.has(String(val));
		})
	);
}

export const clearField = (setFilters, field) =>
	setFilters(prev => {
		const next = new Map(prev);
		// empty selection for this field
		next.set(field, new Set());
		return next;
	}
);

export const clearAll  = setFilters => setFilters(() => new Map());
export const clearOne = (filters, setFilters, field, value) =>
  	setFilters(prev => { const next = new Map(prev); const s = new Set(next.get(field) || []); s.delete(value); next.set(field, s); return next; });

